import { FetchContext } from '../fetch-context';
import { responseErrorHandler } from '../response-error-handler';

export const overrideAwardNominationScrubbing: (
  fetchContext: FetchContext,
  awardId: number,
  nominationId: number,
  overrideJustification: string,
  accessToken?: string,
) => Promise<void> = (fetchContext, awardId, nominationId, overrideJustification, accessToken) => fetch(`${fetchContext.baseUrl}/api/staff/awards/${awardId}/nominations/${nominationId}/scrubbing-status/override`,
  {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ overrideJustification }),
  })
  .then((response) => responseErrorHandler<void>(fetchContext.errorStore, response, 'override award nomination scrubbing'));
